import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '../../common/enums/api-status';
import { downloadProposalDocumentAsync, getDocumentByIdDocumentAsync, getProposalDocsAsync } from './proposalDocumentThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const proposalDocsSlice = createSlice({
    name: 'proposalDocs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProposalDocsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getProposalDocsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.allProposalDocs = action.payload;
        })
            .addCase(getProposalDocsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(downloadProposalDocumentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(downloadProposalDocumentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.docFile = action.payload;
        })
            .addCase(downloadProposalDocumentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDocumentByIdDocumentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDocumentByIdDocumentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.documentPdf = action.payload;
        })
            .addCase(getDocumentByIdDocumentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default proposalDocsSlice.reducer;
